export const INTEGRATIONS_WITHOUT_RESOURCES = [
  "Paystack",
  "SendGrid",
  "Google Mail",
];
